module.exports = __webpack_public_path__ + "img/alipay.0891f3fe.png";